function setupCmsResize() {
    if (window.layoutUpdatePLPPromosInProgress)
        return;

    window.layoutUpdatePLPPromosInProgress = true;
    var indexDecrease = 0;

    for (const element of Array.from(document.querySelectorAll('[data-cy="product-grid"] .cms-module-instance'))) {
        element.classList.add('updated');
        element.classList.add('hide');
    }

    for (const element of Array.from(document.querySelectorAll('[data-cy="product-grid"] .cms-module-instance'))) {
        if (window.matchMedia('(min-width:1008px)').matches) {  //desktop 4x1
            var item_ele = document.querySelectorAll('[data-cy="product-grid"]  [data-item-index]:not(.cms-module-instance.updated)')[parseInt(element.dataset.desktopIndex) - indexDecrease];
            element.parentNode.insertBefore(element, item_ele);
            indexDecrease += ((parseInt(element.dataset.columnSpan) > 4 ? 4 : parseInt(element.dataset.columnSpan)) - 1);

        } else if (window.matchMedia('(min-width:768px)').matches && window.matchMedia('(max-width:1007px)').matches) { //tablet view 3x1
            var item_ele = document.querySelectorAll('[data-cy="product-grid"]  [data-item-index]:not(.cms-module-instance.updated)')[parseInt(element.dataset.tabletIndex) - indexDecrease];
            element.parentNode.insertBefore(element, item_ele);
            indexDecrease += ((parseInt(element.dataset.columnSpan) > 3 ? 3 : parseInt(element.dataset.columnSpan)) - 1);
        }
        else if (window.matchMedia('(max-width:767px)').matches) { //Mobile view 2x1

            var item_ele = document.querySelectorAll('[data-cy="product-grid"]  [data-item-index]:not(.cms-module-instance.updated)')[parseInt(element.dataset.mobileIndex) - indexDecrease];
            element.parentNode.insertBefore(element, item_ele);

            indexDecrease += ((parseInt(element.dataset.columnSpan) > 2 ? 2 : parseInt(element.dataset.columnSpan)) - 1);
        }
        element.classList.remove('updated');
        element.classList.remove('hide');
    }

    window.layoutUpdatePLPPromosInProgress = false;
}

export function setupResize() {
    window.addEventListener('resize', function () { setTimeout(setupCmsResize, 1000); });
    document.addEventListener("products:rehydrate:after", setupCmsResize);
    setupCmsResize();
}
